import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { applyBrandTheme } from "./lib/brand";
import "./styles.css";

// Conservative defaults: a single retry on transient failures, modest stale window.
// Auth state changes via window.location nav, so we don't need aggressive refetch.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

applyBrandTheme(); // brand-tint the surface (buttons/avatar) before first paint

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root mount point missing in index.html");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
